import { FunctionComponent, memo } from 'react';
import { StoryCardPostContent } from '../../../../services';
import { HorizontalStoryFeedCardProps, HorizontalStoryFeedContentCommon } from '../../../../shared';
import { HorizontalStoryFeedAdminCardWrapper } from '../HorizontalStoryFeedAdminCardWrapper';

export const HorizontalStoryFeedAdminPost: FunctionComponent<HorizontalStoryFeedCardProps> = memo(
  ({ card }) => {
    const { type, content, isPinnedToTopOfNewsFeed, isPinnedToTopOfStory } = card;
    const { title, sourceName, abstract } = content as StoryCardPostContent;

    return (
      <HorizontalStoryFeedAdminCardWrapper card={card}>
        <HorizontalStoryFeedContentCommon
          isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
          isPinnedToTopOfStory={isPinnedToTopOfStory}
          cardType={type}
          source={sourceName}
          title={title}
          text={abstract}
        ></HorizontalStoryFeedContentCommon>
      </HorizontalStoryFeedAdminCardWrapper>
    );
  }
);
